import React from 'react'

const AdmisionesGridFecha = ({ data: filteredData }) => {
  return (
    <div>
        <h1 className='text-white mb-2'>Fecha de nacimiento incorrecta</h1>
        <table className="min-w-full divide-y divide-grisMira p-5  shadow-sm shadow-grisMira">
                
                <thead className="sticky top-0 z-10 bg-secundarioMira ">
                  <tr className="w-full divide-x divide-grisMira ">
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 text-center"
                    >
                      Usuario
                    </th>
                    
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira text-center"
                    >
                      Fecha
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira text-center"
                    >
                      Fecha del error
                    </th>
                  </tr>
                </thead>
                

                <tbody className="divide-y divide-grisMira bg-primarioMira w-full">
                  {filteredData?.map((element, index) => (
                        <tr
                          key={index}
                          className={"divide-x divide-grisMira"}
                        >
                          <td className=" whitespace-nowrap p-4 text-sm text-white text-center">
                            <p className={"m-auto"}>{element?.Usuario}</p>
                          </td>

                          <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                            <p className={"m-auto"}>{element?.Fecha}</p>
                          </td>

                          <td className="text-white   whitespace-nowrap  text-sm   text-center p-2">
                          <p className={"m-auto"}>{element?.FechaCambio}</p>  
                          </td>
                        </tr>
                  ))}
                </tbody>
              </table>
    </div>
  )
}

export default AdmisionesGridFecha